export { default } from "./SmallCardView";